import { useRouteLoaderData } from "react-router-dom";
import { useCompany } from "../../Shared/components/CompanyProvider/CompanyProvider";
import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
import { registerEvent } from "./registerUtils";
export const useRegisterForm = () => {
    var _a, _b, _c;
    const { culture } = useCompany();
    const { createKlaviyoEvent, logReactPixel, gaEvent } = useLogging();
    const defaultCountry = ((_c = (_a = culture.countryCode) !== null && _a !== void 0 ? _a : (_b = culture.cultureInfo) === null || _b === void 0 ? void 0 : _b.slice(-2)) !== null && _c !== void 0 ? _c : "US");
    const { referrals, shouldShowPrivacyPolicy, privacyPolicyBannerText, privacyPolicyUrl } = useRouteLoaderData("root-loader");
    return {
        defaultCountry,
        referrals: referrals === null || referrals === void 0 ? void 0 : referrals.sort((a, b) => a.referralId - b.referralId),
        shouldShowPrivacyPolicy: shouldShowPrivacyPolicy !== null && shouldShowPrivacyPolicy !== void 0 ? shouldShowPrivacyPolicy : false,
        privacyPolicyBannerText,
        privacyPolicyUrl,
        registerEvent: registerEvent(createKlaviyoEvent, logReactPixel, gaEvent),
    };
};
